import React from 'react';
import clsx from 'clsx';

import InfoIcon from '@images/info-icon.svg';

type noticeType = 'warning' | 'success';

interface Props {
  type: noticeType;
  text: string;
}

export default function Notice({ type, text }: Props) {
  return (
    <div className={clsx('notice-container', type)}>
      <i className="icon">
        <InfoIcon />
      </i>
      <span className="notice-info" dangerouslySetInnerHTML={{ __html: text }}></span>
    </div>
  );
}
